import React, { useState } from 'react'
import { ModalComponent, Signup, CtaArrow } from 'newComponents'
import { track } from '../../../utils/thirdPartyUtils'
import './styles.scss'

const StartTrialButtonWithModal = (props) => {
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    const { trackEvent } = props
    if (trackEvent) {
      track(trackEvent)
    }
    setModalOpen(!modalOpen)
  }

  return (
    <>
      <div className={props.classes} onClick={toggleModal} data-target="signup" style={props.style} tabIndex="0">
        <span className="navbar-item-name">{props.cta} {props.addArrow && <CtaArrow />}</span>
      </div>
      <ModalComponent modalOpen={modalOpen} toggleModal={toggleModal}>
        <div className="trial-modal-form-card">
          <div className="card formCard">
            <h2 className="title is-2">Start Your 14-Day Trial</h2>
            <p>
              Your 14-day Trial begins as soon as you sign up. We'll get you started with a quick start guide within the
              app.
            </p>
            <p className="u-margintop-medium">
              You'll see how easy it is to manage the whole feature lifecycle from concept to launch to control.
            </p>
            <Signup />
          </div>
        </div>
      </ModalComponent>
    </>
  )
}

export default StartTrialButtonWithModal
